angular.module('mtic').filter('inArray', function($filter){
    return function(list, arrayFilter, listElement, arrayFilterElement){
    	if(!arrayFilterElement) {
    		arrayFilterElement = listElement
    	}
        if(arrayFilter && arrayFilter.length > 0){
            return $filter("filter")(list, function(listItem){
                return arrayFilter.map(function(filterItem) {
                	return filterItem[arrayFilterElement]
                }).indexOf(listItem[listElement]) !== -1;
            });
        }else{
        	// return list;
        	return $filter("filter")(list, function(listItem){
        		return !!listItem[listElement]
        	})
        }
    };
});	
